import React from 'react';
import { Activity, Sparkles, Briefcase, FileText, Calendar, Users, DollarSign, BookOpen, BarChart3, Eye, Settings, HelpCircle, LibraryBig } from 'lucide-react';

const Sidebar = ({ sidebarOpen, activeTab, setActiveTab, userRole, userPermissions, planFeatures }) => {
  const allNavItems = [
    { id: 'dashboard', label: 'Dashboard', icon: Activity },
    { id: 'ai-assistant', label: 'Paralegal', icon: Sparkles },
    { id: 'cases', label: 'Case Management', icon: Briefcase, permission: 'canViewCases' },
    { id: 'documents', label: 'Document Management', icon: FileText, permission: 'canViewCases' },
    { id: 'templates', label: 'Templates', icon: FileText, planGate: 'templates' },
    { id: 'tasks', label: 'Task & Calendar', icon: Calendar, permission: 'canManageTasks' },
    { id: 'clients', label: 'Client Portal', icon: Users, permission: 'canManageClients' },
    { id: 'billing', label: 'Billing & Time', icon: DollarSign, permission: 'canManageBilling' },
    { id: 'legal-research', label: 'Legal Research', icon: BookOpen },
    { id: 'borrow', label: 'Borrow Requests', icon: LibraryBig },
    { id: 'analytics', label: 'Analytics & Reports', icon: BarChart3, permission: 'canViewAnalytics', planGate: 'analytics' },
    { id: 'team', label: 'Team Hub', icon: Users, planGate: 'teamHub' },
    { id: 'audit', label: 'Audit Trail', icon: Eye, adminOnly: true },
    { id: 'admin', label: userRole === 'admin' ? 'Admin Panel' : 'Account', icon: Settings },
    { id: 'contact', label: 'Contact Us', icon: HelpCircle },
  ];

  const navItems = allNavItems.filter(item => {
    if (item.adminOnly) return userRole === 'admin';
    if (item.permission) return userPermissions[item.permission] === true;
    return true;
  });

  return (
    <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
      <nav className="nav">
        {navItems.map(item => {
          const isLocked = item.planGate && planFeatures && !planFeatures[item.planGate];
          return (
            <button
              key={item.id}
              className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
              onClick={() => setActiveTab(item.id)}
              style={isLocked ? { opacity: 0.6 } : {}}
            >
              <item.icon size={20} />
              <span className="nav-label">{item.label}</span>
              {isLocked && sidebarOpen && <span style={{ marginLeft: 'auto', fontSize: '0.7rem', color: '#FFD700' }}>🔒</span>}
            </button>
          );
        })}
      </nav>
    </aside>
  );
};

export default Sidebar;
